import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { report }: Boundaries["editProjectReport"]["request"],
): State {
  const index = state.findIndex((req) => req.report.uuid === report.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { report, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { report, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { report }: Boundaries["editProjectReport"]["success"],
): State {
  const index = state.findIndex((req) => req.report.uuid === report.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { report, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { report, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  { report }: Boundaries["editProjectReport"]["failure"],
): State {
  const index = state.findIndex((req) => req.report.uuid === report.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { report, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { report, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editProjectReportRequested]: handleRequest,
    [events.editProjectReportSucceeded]: handleSuccess,
    [events.editProjectReportFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
